import { render, staticRenderFns } from "./UserAuthForm.vue?vue&type=template&id=ebcca1b0&"
import script from "./UserAuthForm.vue?vue&type=script&lang=js&"
export * from "./UserAuthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports